// Components
import BannerOne from "../../../components/BannerOne";

// Constants
import { TITLE, SUB_TITLE, BUTTON_NAME , BUTTON_LINK, SECOND_BUTTON_NAME, SECOND_BUTTON_LINK} from "./HomepageConstants";
import { LAST_BUTTON_NAME, LAST_BUTTON_LINK } from "./HomepageConstants";

// Images
import homepageBanner from '../../../assets/img/partnerPortal/homepage.png';
import aws from '../../../assets/img/partnerPortal/homepage/logo-aws.png';
import azure from '../../../assets/img/partnerPortal/homepage/logo-azure.png';
import google from '../../../assets/img/partnerPortal/homepage/logo-google.png';
import redHat from '../../../assets/img/partnerPortal/homepage/logo-redhat.png';
import accenture from '../../../assets/img/partnerPortal/homepage/logo-accenture.png';
import deloitte from '../../../assets/img/partnerPortal/homepage/logo-deloitte.png';
import dxc from '../../../assets/img/partnerPortal/homepage/logo-dxc.png';
import kyndryl from '../../../assets/img/partnerPortal/homepage/logo-kyndryl.png';

// Scss
import '../../../assets/css/partnerProgram.scss';
import TitleSubTitleCenter from "../../../components/TitleSubTitleCenter";
import ButtonArrow from "../../../components/ButtonArrow";
import { Carousel } from "react-bootstrap";

function HomepageNew() {

//   let history = useHistory();

//   useEffect(() => {
//     canYouHaveAccess();


//   }, []);

  return (
    <>
      <div>

        <BannerOne bannerImage={homepageBanner} title={TITLE} subTitle={SUB_TITLE} buttonName={BUTTON_NAME} buttonLink={BUTTON_LINK} secondButtonName={SECOND_BUTTON_NAME} secondButtonLink={SECOND_BUTTON_LINK} lastButtonName={LAST_BUTTON_NAME} lastButtonLink={LAST_BUTTON_LINK}/>
        <div className="containerAll">
            <TitleSubTitleCenter sectionWidth="width80" title={"A symbiotic ecosystem that drives customer innovation, automation, and modernization"} 
                subTitle={"The Dynatrace partner program isn’t just another vendor program. It’s a rich, vibrant community comprising industry experts, " +
                "visionaries, thought leaders, and practitioners that together that together solve the challenges enterprise organizations face with cloud adoption " +
                 "and modernization."} />
            <div className="d-flex align-items-start w-100 justify-content-center">
                <div className="cardCol">
                        <img src={aws} alt='...' width={"70%"}  />
                </div>
                <div className="cardCol">
                    <img src={azure} alt='...' width={"70%"}   />
                </div>
                <div className="cardCol">
                        <img src={google} alt='...' width={"70%"} />
                </div>
                <div className="cardCol">
                    <img src={redHat} alt='...' width={"70%"}  />
                </div>
            </div>   
            <div className="d-flex align-items-start w-100 justify-content-center mb-5">
                <div className="cardCol">
                        <img src={accenture} alt='...' width={"70%"}  />
                </div>
                <div className="cardCol">
                    <img src={deloitte} alt='...'width={"70%"}  />
                </div>
                <div className="cardCol">
                        <img src={dxc} alt='...' width={"70%"}  />
                </div>
                <div className="cardCol">
                    <img src={kyndryl} alt='...' width={"70%"}  />
                </div>
            </div>   

            <TitleSubTitleCenter addClass={"mt-5"} sectionWidth="width80" title={"Choose a partner program that’s right for your business"} 
                subTitle={"Every partner organization is different, which is why we designed the Dynatrace partner program with multiple pathways, " +
                "each purpose-built to maximize partner value through training, enablement, and certification that’s tightly coupled with go-to-market support and investment."} />

            <div className="align-items-start displayFlex mt-4">
                <div className="d-flex flex-column align-items-center cardBackground width31 mr-4 ml-3">
                    <div className="d-flex flex-column align-items-start align-self-stretch w-100 cardPadding">
                        <div className="d-flex flex-column align-items-center align-self-stretch mb-4">
                            <div className="d-flex align-items-start align-self-stretch cardTitleApp mb-2">Sales Partners</div>
                            <div className="d-flex align-items-start align-self-stretch justify-content-center cardSubTitleApp mb-2">Grow pipeline, revenue, and profitability through Dynatrace platform sales and value-add services. 
                            </div>
                        </div>
                        <div className="d-flex align-items-start w-100 justify-content-center mb-3">
                            <Carousel>
                                <Carousel.Item>
                                            <img src={aws}  />
                                </Carousel.Item>
                                <Carousel.Item>
                                            <img src={azure}  />  
                                </Carousel.Item>
                            </Carousel>
                        </div>
                        <ButtonArrow link={"https://partners.dynatrace.com/#/page/other-test"} target="_parent" buttonName={"Learn More"} width="15%" />

                    </div>
                </div>
                <div className="d-flex flex-column align-items-center cardBackground width31 mr-4 ">
                    <div className="d-flex flex-column align-items-start align-self-stretch w-100 cardPadding">
                        <div className="d-flex flex-column align-items-center align-self-stretch">
                            <div className="d-flex align-items-start align-self-stretch cardTitleApp mb-2">Services Partners</div>
                            <div className="d-flex align-items-start align-self-stretch justify-content-center cardSubTitleApp mb-2">
                            Build and power services practices and offerings that differentiate through value realization.
                            </div>
                        </div>
                        <div className="d-flex align-items-start w-100 justify-content-center mt-4 mb-3">
                            <Carousel>
                                <Carousel.Item>
                                            <img src={accenture}  />
                                </Carousel.Item>
                                <Carousel.Item>
                                            <img src={dxc}  />  
                                </Carousel.Item>
                                <Carousel.Item>
                                            <img src={deloitte} />  
                                </Carousel.Item>
                                <Carousel.Item>
                                            <img src={kyndryl}  />  
                                </Carousel.Item>
                            </Carousel>
                        </div>
                        <ButtonArrow link={"https://partners.dynatrace.com/#/page/other-test"} target="_parent" buttonName={"Learn More"} width="15%" />

                    </div>
                </div>
                <div className="d-flex flex-column align-items-center cardBackground width31 ">
                    <div className="d-flex flex-column align-items-start align-self-stretch w-100 cardPadding">
                        <div className="d-flex flex-column align-items-center align-self-stretch">
                            <div className="d-flex align-items-start align-self-stretch  cardTitleApp mb-2">Technology Alliances</div>
                            <div className="d-flex align-items-start align-self-stretch justify-content-center cardSubTitleApp mb-2">
                            Integrate, extend, and innovate with market leading technologies and capabilities.
                            </div>
                        </div>
                        <div className="d-flex align-items-start w-100 justify-content-center mt-4 mb-3">
                            <Carousel>
                                <Carousel.Item>
                                            <img src={aws}  />
                                </Carousel.Item>
                                <Carousel.Item>
                                            <img src={azure} />  
                                </Carousel.Item>
                                <Carousel.Item>
                                            <img src={google}   />  
                                </Carousel.Item>
                                <Carousel.Item>
                                            <img src={redHat}/>  
                                </Carousel.Item>
                            </Carousel>
                        </div>
                        <ButtonArrow link={"https://partners.dynatrace.com/#/page/other-test"} target="_parent" buttonName={"Learn More"} width="15%" />
                    </div>
                </div>
            </div>
            {/* <div className="align-items-start displayFlex mt-4 w-100">
                <div className="d-flex flex-column align-items-center cardBackground w-100 mr-4 ml-3">
                    <div className="d-flex flex-column align-items-start align-self-stretch w-100 cardPadding">
                        <div className="d-flex flex-column align-items-center align-self-stretch mb-4">
                            <div className="d-flex align-items-start align-self-stretch cardTitleApp mb-2">MSPs</div>
                            <div className="d-flex align-items-start align-self-stretch justify-content-center cardSubTitleApp mb-2">Deliver managed services across the entire Observability lifecycle. 
                            </div>
                        </div>
                        <div className="d-flex align-items-start w-100 justify-content-center mt-3">
                            <div className="cardCol">
                                <img src={accenture} alt='...' width={"100%"}  />
                            </div>
                            <div className="cardCol">
                                <img src={deloitte} alt='...'width={"100%"}  />
                            </div>
                            <div className="cardCol">
                                    <img src={dxc} alt='...' width={"100%"}  />
                            </div>
                            <div className="cardCol">
                                <img src={kyndryl} alt='...' width={"100%"}  />
                            </div>
                        </div>
                        <ButtonArrow link={"https://developer.dynatrace.com/"} buttonName={"Learn More"} width="15%" />

                    </div>
                </div>
            </div> */}
        </div>
      </div >
    </>
  );

//   function canYouHaveAccess() {
//     try {
//       if (process.env.REACT_APP_PROTECT_PAGE === "true" && window.top?.location.host !== process.env.REACT_APP_ALLOW_API) {
//         console.log("You shall not pass");
//         history.push('/not-found');
//       }
//     } catch (err) {
//       

//     }
//   }

}

export default HomepageNew;

